var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 331,
    viewBox: "0 0 331 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_206)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 331C256.903 331 331 256.903 331 165.5C331 74.0969 256.903 0 165.5 0C74.0969 0 0 74.0969 0 165.5C0 256.903 74.0969 331 165.5 331Z",
    fill: "#41BBE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_206",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 63,
    width: 200,
    height: 198
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.09 63.59H65.92V260.92H264.09V63.59Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.2 198.83C175.632 198.83 185.71 188.752 185.71 176.32C185.71 163.888 175.632 153.81 163.2 153.81C150.768 153.81 140.69 163.888 140.69 176.32C140.69 188.752 150.768 198.83 163.2 198.83Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19 206.53C140.13 206.53 121.44 225.22 121.43 248.28C121.43 254.33 126.34 259.24 132.39 259.24H193.99C200.04 259.24 204.95 254.33 204.95 248.28C204.95 225.22 186.25 206.53 163.19 206.53Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.11 154.85C249.11 163.44 242.15 170.39 233.57 170.4C224.98 170.4 218.03 163.44 218.03 154.86C218.03 146.28 224.99 139.31 233.57 139.31C242.16 139.31 249.11 146.27 249.11 154.85Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56 175.72C217.63 175.72 204.72 188.63 204.72 204.56C204.72 208.74 208.11 212.13 212.29 212.13H254.84C259.02 212.13 262.41 208.74 262.41 204.56C262.41 188.63 249.5 175.72 233.57 175.72H233.56Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.81 80.82C181.81 89.41 174.85 96.37 166.27 96.37C157.69 96.37 150.72 89.41 150.72 80.82C150.72 72.23 157.68 65.28 166.27 65.28C174.86 65.28 181.81 72.24 181.81 80.82Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.26 101.68C150.33 101.68 137.42 114.59 137.42 130.52C137.42 134.7 140.81 138.09 144.99 138.09H187.54C191.72 138.09 195.11 134.7 195.11 130.52C195.11 114.59 182.2 101.68 166.27 101.68H166.26Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.98 154.85C111.98 163.44 105.02 170.39 96.44 170.4C87.85 170.4 80.89 163.44 80.89 154.86C80.89 146.28 87.85 139.31 96.43 139.31C105.02 139.31 111.98 146.27 111.98 154.85Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44 175.72C80.51 175.72 67.6 188.63 67.6 204.56C67.6 208.74 70.99 212.13 75.17 212.13H117.72C121.9 212.13 125.29 208.74 125.29 204.56C125.29 188.63 112.38 175.72 96.45 175.72H96.44Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 331,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.b8147201130f66e6e869ede0801d4733.svg";
export { ForwardRef as ReactComponent };